import { z } from 'zod';
import { ApiMethod } from '../types/api.types';
import { projectParamsSchema } from '../types/payloads/project.payload';
import {
    teamAccessRequestParamsSchema,
    teamAccesssRequestAcceptBody,
    teamParamsSchema
} from '../types/payloads/team.payload';
import { workspaceTeamAccessRequestSchema } from '../types/team.types';

export const API_WORKSPACE_PROJECT_ACCESS_REQUEST = {
    LIST: {
        path: '/workspaces/:workspaceName/projects/:projectUuid/access-requests',
        method: ApiMethod.GET,
        zod: {
            params: projectParamsSchema
        },
        handlerMethod: 'listTeamWorkspaceAccessRequests',
        responses: {
            200: {
                description: 'List of access requests for a project',
                schema: z.array(workspaceTeamAccessRequestSchema)
            }
        }
    },
    POST_TEAM: {
        //bypass workspace user auth by not prefixing with workspaces/:workspaceName
        path: '/workspace-access-requests/:workspaceName/projects/:projectUuid/teams/:teamUuid',
        method: ApiMethod.POST,
        zod: {
            params: teamParamsSchema
        },
        handlerMethod: 'postTeamWorkspaceAccessRequest'
    },
    PUT: {
        path: '/workspaces/:workspaceName/projects/:projectUuid/teams/:teamUuid/access-requests/:accessRequestUuid',
        method: ApiMethod.PUT,
        zod: {
            params: teamAccessRequestParamsSchema,
            body: teamAccesssRequestAcceptBody
        },
        handlerMethod: 'acceptTeamWorkspaceAccessRequest'
    },
    DELETE: {
        path: '/workspaces/:workspaceName/projects/:projectUuid/teams/:teamUuid/access-requests/:accessRequestUuid',
        method: ApiMethod.DELETE,
        zod: {
            params: teamAccessRequestParamsSchema
        },
        handlerMethod: 'deleteTeamWorkspaceAccessRequest'
    }
} as const;
